import { createGlobalStyle } from 'styled-components';

export const darkTheme = {
  colors: {
    primary: '#00A8FF',      // Bright Blue
    background: '#0D1117',   // GitHub Dark Background
    surface: '#161B22',      // Card/Nav surface
    surface2: '#21262D',     // Lighter surface
    text: '#E6EDF3',         // Light Text
    textSecondary: '#8B949E',// Secondary Text
    accent: '#56E39F',       // Bio-tech Green
    accent2: '#F0B90B',      // Gold/Warning
    error: '#F85149',
  },
  fonts: ['Inter', 'sans-serif'],
  shadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
};

export const lightTheme = {
  colors: {
    primary: '#1976D2',      // Darker Blue
    background: '#F0F2F5',   // Light Background
    surface: '#FFFFFF',      // White surface
    surface2: '#F9F9F9',
    text: '#24292F',         // Dark Text
    textSecondary: '#57606A',// Grey Secondary
    accent: '#00C853',       // Green accent
    accent2: '#FFA000',
    error: '#D32F2F',
  },
  fonts: ['Inter', 'sans-serif'],
  shadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
};

export const GlobalStyle = createGlobalStyle`
  /* --- *** THE @import IS GONE FROM HERE *** --- */

  body {
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    font-family: ${props => props.theme.fonts[0]};
    margin: 0;
    padding: 0;
    transition: background-color 0.2s linear, color 0.2s linear;
  }
`;